// @vendors
import { useEffect, useContext, useState } from "react"
import { Form, Input } from 'antd'
import Context from '../../../context/appContext';
import { getDate, getDependencyValue } from '../../../utils/utils';
import cx from 'classnames'
import { agentEmailKey } from "../../../pages/quotation"

export default function TextField({ info, form, key, current }) {
    const validate = info.validate ? info.validate : {};
    const [fieldValueEqual, setFieldValueEqual] = useState("");
    const [message, setMessage] = useState({ help: '', status: 'success' });
    const { dataForm: { data, formResponses, hiddenFields, disabledFields }, setDataForm } = useContext(Context);

    useEffect(() => {
        getDefaultValue();
        if (formResponses.findIndex(x => x.key === info.key) === -1) {
            formResponses.push(info);
        }
        if (info.properties && info.properties.equal) {
            const keyFieldEqual = info.properties.equal;
            const fieldValEqual = formResponses && formResponses.find(t => t.key.includes(keyFieldEqual));
            setFieldValueEqual(fieldValEqual ? fieldValEqual.value : "");
        }
    }, []);

    useEffect(() => {
        disabledFields[info.key] && getDefaultValue();
    }, [disabledFields[info.key]]);

    const onChange = (event) => {
        if (info.key === "codigoPostal") {
            form.resetFields(["estadoAsegurado", "coloniaAsegurado", "ciudadAsegurado", "municipioAsegurado"]);
        } else if (info.key === "codigoPostalContratante") {
            form.resetFields(["estadoContratante", "coloniaContratante", "ciudadContratante", "municipioContratante"])
        }
        let value = event.target.value;
        if (fieldValueEqual) {
            setMessage(fieldValueEqual !== value ? { help: 'Correo electrónico no coincide', status: 'error' } :
                { help: '', status: 'success' });
        } else {
            setValue(info.key.includes("identificadorPersona") ? value.toUpperCase() : value);
        }
    }

    const onBlur = (event) => {
        let value = event.target.value;
        if (info && info.key.includes('identificadorPersonaAdicional') || info.key.includes('identificadorPersonaTitular')) {
            const insuredDate = formResponses && formResponses
                .find(fr => fr.key.includes(info.key.split('-')[1]) && fr.key.includes('fechaNacimiento'));

            if (getDate(insuredDate.value) < 18) {
                validate.minLength = 10;
                info.errorLabel = 'Es necesario capturar el RFC a mínimo 10 posiciones';
                if (insuredDate && insuredDate.value && value.length >= validate.minLength && value.length < validate.maxLength) {
                    const nValue = value.padEnd(validate.maxLength, "0");
                    form.setFieldsValue({ [info.key]: nValue });
                    setValue(nValue);
                }
            }
        }

        if (Number(value) && info.properties && info.properties.fixed) {
            value = Number(value).toFixed(Number(info.properties.fixed));
            if (new RegExp(validate.pattern).test(value) && value.length <= validate.maxLength) {
                form.setFieldsValue({ [info.key]: value });
                setValue(value);
            }
        }

        const dependencyValue = getDependencyValue(current, info.key, event.toString(), []);
        if (dependencyValue && dependencyValue.length > 0) {
            dependencyValue.forEach(item => {
                const keyLcl = Object.keys(item)[0];
                form.setFieldsValue({ [keyLcl]: '' });
                hiddenFields[keyLcl] = item[keyLcl];
            });
            setDataForm({ data, formResponses, hiddenFields: hiddenFields, disabledFields });
        }
    }

    const calculateValue = () => {
        const fieldsCalculated = formResponses.filter((item) => item.calculateValue && item.type === info.type);
        fieldsCalculated && fieldsCalculated.forEach(element => {
            let isOk = true;
            let operation = element.calculateValue.operation;
            const calculateValueFields = element.calculateValue.fields;
            calculateValueFields && calculateValueFields.length > 0 && calculateValueFields.forEach(field => {
                const fieldInfo = formResponses.find((value) => value.key === field);
                const regex = new RegExp(field, 'ig');
                operation = operation.replace(regex, fieldInfo && fieldInfo.value);
                if (!(fieldInfo && fieldInfo.value && new RegExp(fieldInfo.validate.pattern).test(fieldInfo.value)))
                    isOk = false;
            });
            if (isOk && operation) {
                try {
                    const index = formResponses.findIndex(x => x.key === element.key);
                    const result = eval(operation).toFixed(formResponses[index].properties && formResponses[index].properties.fixed);
                    formResponses[index].value = result;
                    form.setFieldsValue({ [formResponses[index].key]: result });
                } catch (error) {

                }
            }
        });
    }

    const setValue = (value) => {
        const index = formResponses.findIndex(x => x.key === info.key);
        if (validate.pattern) {
            const pattern = new RegExp(validate.pattern).test(value);
            info.value = pattern ? value : '';
            index != -1 ? formResponses[index].value = pattern ? value : '' : formResponses.push(info);
        } else {
            info.value = value;
            index != -1 ? formResponses[index].value = value : formResponses.push(info);
        }
        calculateValue();
    }

    const getDefaultValue = () => {
        const chkData = formResponses.find((item) => item.key === "datosContratanteIgualAsegurado");
        const hasCheckLoadLastStepInfo = current.newItems.find(x => x && x.key === "datosContratanteIgualAsegurado");

        let value = '';
        if (info.customDefaultValue && (!hasCheckLoadLastStepInfo || (hasCheckLoadLastStepInfo && chkData && chkData.value))) {
            const item = formResponses.find((x) => x.key.includes(info.customDefaultValue));
            value = item && item.value ? item.value : '';
            disabledFields[info.key] = true;
            setDataForm({ data, formResponses, hiddenFields, disabledFields: disabledFields });
        } else if (info && info.value && info.value !== null && info.value !== '') {
            value = info.value;
        }

        if (value && value !== '') {
            form.setFieldsValue({ [info.key]: value });
            onChange({ target: { value: value } });
        }
    }

    return (
        <Form.Item
            label={info.label}
            name={info.key}
            key={key}
            hidden={hiddenFields[info.key]}
            className={
                cx(
                    {
                        'ant-form-item-disabled': info.disabled
                    },
                    {
                        'uppercase': info.key.includes("identificadorPersona")
                    }
                )
            }
            rules={[
                {
                    required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                    message: "Este campo es requerido"
                },
                {
                    pattern: new RegExp(validate.pattern),
                    message: validate.customMessage
                },
                {
                    min: validate.minLength ? validate.minLength : 1,
                    max: validate.maxLength ? validate.maxLength : 100,
                    message: info && info.errorLabel ? info.errorLabel : "Longitud de carácteres no válido"
                },
                {
                    pattern: new RegExp(message.status === 'error' ? 'error' : ''),
                    message: message.help
                }
            ]}
            tooltip={info.tooltip ? info.tooltip : null}
        >
            <Input
                placeholder={info.placeholder}
                id={info.key}
                readOnly={info.hidden}
                disabled={disabledFields[info.key] && info.key!==agentEmailKey}
                minLength={validate.minLength}
                maxLength={validate.maxLength}
                onChange={onChange}
                onBlur={onBlur}
                autoComplete="off"
            />
        </Form.Item>
    )
}